import OrganizationIcon from '../../assets/svg/login_account_org.svg';
import OrganizationIconMobile from '../../assets/svg/login_account_org_mobile.svg';
import PersonalIcon from '../../assets/svg/login_account_personal.svg';
import PersonalIconMobile from '../../assets/svg/login_account_personal_mobile.svg';
import SelectedControl from '../../assets/svg/login_account_selected.svg';
import SelectedControlMobile from '../../assets/svg/login_account_selected_mobile.svg';
import UnselectedControl from '../../assets/svg/login_account_unselected.svg';
import UnselectedControlMobile from '../../assets/svg/login_account_unselected_mobile.svg';

import {Button, Modal} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './LoginAccountSelection.css';

const LoginAccountSelection = ({
  accounts,
  selectedAccountId,
  customerId,
  onContinue,
}) => {
  const {t} = useTranslation();
  const [pendingAccountId, setPendingAccountId] =
    React.useState(selectedAccountId);
  const pendingAccount = accounts.find(
    (account) => account.id === pendingAccountId
  );

  return (
    <Modal
      open={true}
      showClose={false}
      disableEscapeKeyDown
      maxWidth={false}
      className="login-account-modal"
      aria-labelledby="login-account-title"
      aria-describedby="login-account-description"
    >
      <div className="login-account-header">
        <h2 id="login-account-title">{t('SELECT_ACCOUNT')}</h2>
        <p id="login-account-description" data-sl="mask">
          {t('SELECT_ACCOUNT_DESCRIPTION', {customerId})}
        </p>
      </div>
      <div
        className="login-account-list"
        role="radiogroup"
        aria-labelledby="login-account-title"
      >
        {accounts.map((account) => {
          const isSelected = account.id === pendingAccountId;
          return (
            <label
              key={account.id}
              className={
                isSelected
                  ? 'login-account-option login-account-option-selected'
                  : 'login-account-option'
              }
            >
              <span className="login-account-control">
                <input
                  type="radio"
                  name="login-account"
                  value={account.id}
                  checked={isSelected}
                  onChange={() => setPendingAccountId(account.id)}
                  aria-labelledby={`login-account-name-${account.id}`}
                  aria-describedby={`login-account-details-${account.id}`}
                />
                <picture>
                  <source
                    media="(max-width: 768px)"
                    srcSet={
                      isSelected
                        ? SelectedControlMobile
                        : UnselectedControlMobile
                    }
                  />
                  <img
                    src={isSelected ? SelectedControl : UnselectedControl}
                    alt=""
                  />
                </picture>
              </span>
              <span className="login-account-icon">
                <picture>
                  <source
                    media="(max-width: 768px)"
                    srcSet={
                      account.isPersonal
                        ? PersonalIconMobile
                        : OrganizationIconMobile
                    }
                  />
                  <img
                    src={account.isPersonal ? PersonalIcon : OrganizationIcon}
                    alt=""
                  />
                </picture>
              </span>
              <span className="login-account-details">
                <span
                  id={`login-account-name-${account.id}`}
                  className="login-account-name"
                  data-sl="mask"
                >
                  {account.name}
                </span>
                <span
                  id={`login-account-details-${account.id}`}
                  className="login-account-description"
                >
                  <span className="login-account-type">
                    {t(
                      account.isPersonal
                        ? 'INDIVIDUAL_ACCOUNT'
                        : 'ORGANIZATION_ACCOUNT'
                    )}
                  </span>
                  <span className="login-account-metadata">
                    <span className="login-account-contracts">
                      {t(
                        account.activeContractCount
                          ? 'ACCOUNT_ACTIVE_CONTRACTS'
                          : 'ACCOUNT_NO_ACTIVE_CONTRACTS',
                        {count: account.activeContractCount}
                      )}
                    </span>
                  </span>
                </span>
              </span>
            </label>
          );
        })}
      </div>
      <div className="login-account-footer">
        <p>{t('ONE_ACTIVE_ACCOUNT')}</p>
        <Button
          variant="primary"
          className="login-account-continue"
          disabled={!pendingAccount}
          onClick={() => onContinue(pendingAccount)}
        >
          {t('CONTINUE')}
        </Button>
      </div>
    </Modal>
  );
};

export default LoginAccountSelection;
